// Module
var code = "<div class=\"block-13__image image\"></div> ";
// Exports
export default code;